import routes from "./Routes";

const OktaConfig = {
    // Required config
    // issuer: "https://login-preprod.uts.edu.au/oauth2/default",
    issuer: process.env.REACT_APP_OKTA_ISSUER,

    // Required for login flow using getWithRedirect()
    //clientId: "0oaxj9sv2AkpMYWlF3l6",
    clientId: process.env.REACT_APP_OKTA_CLIENTID,

    redirectUri: `${window.location.origin}${routes.oktaCallback}`,
    // redirectUri: `${window.location.origin}${routes.oktaCallback}`,

    scopes: ["openid", "profile", "email"],

    // Parse authorization code from hash fragment instead of search query
    // responseMode: "fragment",

    // Configure TokenManager to use sessionStorage instead of localStorage
    // tokenManager: {
    //     storage: "sessionStorage",
    // },
};

export default OktaConfig;
